module.exports = __webpack_public_path__ + "assets/img/code2.7a6f8c6e.png";